module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-orange-944002ab28cf2e74f0d31c8207e5871c.svg";